module.exports = __webpack_public_path__ + "static/media/Data_insight_3-1.3af0d462.svg";